<div class="content">
    <app-header></app-header>
    <mat-progress-bar mode="indeterminate" *ngIf="showProgressBar"></mat-progress-bar>
    <router-outlet></router-outlet>
</div>
